export default __webpack_public_path__ + "static/media/PEGI_6.f171ab15.svg";